// Project roles offered for each senior/key person. Shared by the questionnaire
// and every biosketch form so the same person shows the same role everywhere.
export const PROJECT_ROLES = ['PI', 'Co-I', 'Consultant', 'Other (Specify)'];

// Biosketches saved before the lists were unified used longer labels.
const LEGACY_ROLE_MAP = {
  'Principal Investigator': 'PI',
  'Co-PI': 'PI',
  'Co-Investigator': 'Co-I',
  Other: 'Other (Specify)'
};

export const normalizeProjectRole = (role) => LEGACY_ROLE_MAP[role] || role || '';

// Key personnel are matched across pages by name.
export const isSamePerson = (a = {}, b = {}) =>
  String(a.firstName || '').trim().toLowerCase() === String(b.firstName || '').trim().toLowerCase()
  && String(a.lastName || '').trim().toLowerCase() === String(b.lastName || '').trim().toLowerCase();
